/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVendorsQuery } from '../../models/get-vendors-query';
import { GetVendorsQueryResult } from '../../models/get-vendors-query-result';

export interface ApiVendorsGetVendorsPost$Params {
  
    /**
     * The query parameters for fetching Vendor .
     */
    body?: GetVendorsQuery
}

export function apiVendorsGetVendorsPost(http: HttpClient, rootUrl: string, params?: ApiVendorsGetVendorsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVendorsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiVendorsGetVendorsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetVendorsQueryResult>;
    })
  );
}

apiVendorsGetVendorsPost.PATH = '/api/Vendors/GetVendors';
